import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import { PrivateRoutes } from "./private";
import { publicV2Routes } from "./namespaces";

const AppRoutes = () => {
  return (
    <>
      <Suspense>
        <Routes>
          {/* Private Routes */}
          <Route path="*" element={<PrivateRoutes />} />

          {/* Public Routes */}
          {publicV2Routes.map(({ path, component }) => (
            <Route key={path} path={path} element={component} />
          ))}
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
